<div class="row align-items-center mb-3">
  @if (proposal) {
    <div class="col-12">
      @if (loading) {
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      }
      @if (!loading) {
        <div class="btn-group single-button-group" role="group">
          <button
            type="button"
        [ngClass]="{'btn': true, 'btn-success': true, 'scope-change-btn': true, 
                   'scope-change-compact': !proposal.isShowButton || scopeChanges.length <= 3}"
        (click)="createNewScopeChange()"
            >
            <div class="scope-button-content">
              <div class="scope-title">Change</div>
              <div class="scope-details">of</div>
              <div class="scope-status bold">Scope</div>
            </div>
          </button>
          <ng-container>
            @for (change of scopeChanges; track change; let i = $index) {
              <button
                type="button"
                class="btn btn-primary"
                title="Status: {{ change.status }}"
                (click)="goToProposalChildren(change.proposalId)"
                >
                <div class="scope-button-content">
                  <div class="scope-title">Scope {{ i + 1 }}</div>
                  <div class="scope-details">{{ change.code }} - {{ change.proposalTime | date:'dd/MM/yyyy' }}</div>
                  <div class="scope-status">{{ change.status }}</div>
                </div>
              </button>
            }
            @if (scopeChanges.length === 0) {
              <span class="no-changes-message ms-3 d-flex align-items-center">
                No scope changes available
              </span>
            }
          </ng-container>
        </div>
      }
    </div>
  }
</div>
